import React, { useContext, useEffect, useState } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { Icon } from '@iconify/react';

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const { isDark } = useContext(StyleContext);
  const [isVisible, setIsVisible] = useState(Array(bigProjects.projects.length).fill(false));

  const toggleVisibility = (index) => {
    setIsVisible((prevState) => {
      // const newState = Array(bigProjects.projects.length).fill(false);
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  useEffect(() => {
    toggleVisibility(5);
  },[]);

  if (!bigProjects.display) {
    return null;
  }
  const pixel = require("./../../assets/images/Pixel_8_Shell.png");
  return (
    <div className="main" id="projects">
      <div>
        <h1 className="skills-heading">{bigProjects.title}</h1>
        <p
          className={
            isDark
              ? "dark-mode project-subtitle"
              : "subTitle project-subtitle"
          }
        >
          {bigProjects.subtitle}
        </p>

        <div className="projects-container">
          {bigProjects.projects.map((project, i) => {
            return (
              <div
                key={i}
                className={
                  isDark
                    ? "dark-mode project-card project-card-dark"
                    : "project-card project-card-light"
                }
              >
                {project.image ? (
                  <div className="project-image">
                    <img
                      src={project.image}
                      alt={project.projectName}
                      className="card-image"
                    ></img>
                  </div>
                ) : null}
                <div className="project-detail">
                  <h5
                    className={isDark ? "dark-mode card-title" : "card-title"}
                  >
                    {project.projectName}
                  </h5>
                  <p
                    className={
                      isDark ? "dark-mode card-subtitle" : "card-subtitle"
                    }
                  >
                    {project.projectDesc}
                  </p>
                  {project.footerLink ? (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, j) => {
                        return (
                          <span
                            key={j}
                            className={
                              isDark ? "dark-mode project-tag" : "project-tag"
                            }
                            onClick={function () {
                              if (link.name === 'Checkout')
                                toggleVisibility(i);
                              else
                                openUrlInNewTab(link.url)
                            }}
                          >
                            {link.platform ? <Icon icon={link.platform === "android" ? "teenyicons:google-play-store-solid" : link.platform === "ios" ? "f7:logo-ios" : "f7:logo-macos"} className="store-icon" /> : null}
                            {link.name === 'Checkout' ? isVisible[i] ? 'Hide' : 'Checkout' : link.name}
                          </span>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
                {
                  isVisible[i] &&
                  <div className="phone">
                    <div class="loader" id={"loader" + i}></div>
                    <iframe title={project.projectName} src={project.appUrl} frameBorder={0} scrolling="no" onLoad={function () {
                      var loader = document.getElementById("loader" + i);
                      if (loader) {
                        loader.style.display = 'none';
                      }
                    }} />
                    <img src={pixel} alt="App Implementation" />
                  </div>
                }
                {
                  isVisible[i] && project.notes &&
                  <div className="notes">
                    {project.notes.map((note, key) => (note ? <p key={key}>{note}</p> : null))}
                  </div>
                }
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
